import { useEffect, useState } from 'react';

export const useDebounce = (value = '', delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const clearDebouncedValue = () => {
    setDebouncedValue('');
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return { debouncedValue, clearDebouncedValue };
};
